<div class="modal-body">
  @if (userLoaded === false) {
  <div class="mt-2 w-100">
    <i-title [text]="'recipients.title' | translate" [buttons]="titleButtonsLoading" level="1"></i-title>
  </div>
  <div class="row">
    <div class="col-md-12 text-center">
      <img src="./assets/img/loupe-loader.gif" class="img-fluid" alt="" />
    </div>
  </div>
  }
  @if (userLoaded) {
  <div class="mt-2 w-100">
    <i-title [text]="'recipients.title' | translate" [buttons]="titleButtons" level="1"></i-title>
  </div>
  <div class="row">
    <div class="panel-header col-md-12 mb-3">
      <div class="mb-3 d-flex justify-content-center">
        <i-tabs class="box" [items]="searchTabs" (tabChange)="switchTabs({ value: $event })" [align]="'center'">
        </i-tabs>
      </div>
    </div>
    <div class="container">
      <div class="row">
        @if (destinatairesNamePresent) {
        <div class="col-md-12">
          <div class="alert alert-primary">
            {{ 'recipients.recipientsAlreadyPresent' | translate }} ({{ recipientsNames.length }})
            <div>{{ destinatairesNamePresent }}</div>
          </div>
        </div>
        }
        <section class="panel-content col-md-12">
          @if (selectedTabs.value !== 'free') {
          <div>
            @if (selectedTabs.value === 'contacts') {
            <div class="d-flex align-items-center">
              <i-button id="addContactRecipientModal" text="Ajouter un contact" styleClass="green mb-3" size="small"
                (click)="openNewContact()"></i-button>
            </div>
            }
            @if (selectedTabs.value === 'contacts') {
            <app-super-list-simple [isAllowedToFilterByStateActive]="true" [typeOfContact]="'contact'"
              [items]="filteredContacts" [height]="'40vh'" [typeContact]="typeContact" id="contactTableDestinataire"
              [destinataire]="true" [columns]="cols" alignLast="right " [boolMultiSelect]="true"
              (multiSelectValue)="onChangeContacts($event)" [boolImageMode]="true" [servicesList]="serviceParent"
              icon="icon-start-full">
            </app-super-list-simple>
            }
            @if (selectedTabs.value === 'groups') {
            <app-super-list-simple [items]="filteredGroups" [height]="'40vh'" [showGroup]="true"
              id="groupeTableDestinataire" [destinataire]="true" [columns]="cols" alignLast="right "
              [boolMultiSelect]="true" (multiSelectValue)="onChangeGroups($event)" [boolImageMode]="true"
              icon="icon-start-full">
            </app-super-list-simple>
            }
            @if (selectedTabs.value === 'services') {
            <app-super-list-simple [items]="filteredServices" [height]="'40vh'" [showGroup]="true"
              id="serviceTableDestinataire" [destinataire]="true" [columns]="cols" alignLast="right "
              [boolMultiSelect]="true" (multiSelectValue)="onChangeServices($event)" [boolImageMode]="true"
              icon="icon-start-full">
            </app-super-list-simple>
            }
            @if (selectedTabs.value === 'users') {
            <app-super-list-simple [items]="filteredUsers" [isAllowedToFilterByStateActive]="true"
              [typeOfContact]="'user'" id="userTableDestinataire" [destinataire]="true" [height]="'40vh'"
              [columns]="cols" alignLast="right " [boolMultiSelect]="true" (multiSelectValue)="onChangeUsers($event)"
              [boolImageMode]="true" [servicesList]="serviceParent" icon="icon-start-full">
            </app-super-list-simple>
            }
          </div>
          }
          @if (selectedTabs.value === 'free') {
          <div class="py-2">
            <label for="addFreeRecipientInput " class="custom-h4-title ms-2">{{ 'recipients.freeRecipient' | translate
              }}</label>
            <div class="alert alert-primary">{{ 'recipients.enterRecipientsSeparatedBySemicolon' | translate }}</div>
            <div class="row">
              <div class="col-md-12 mb-4">
                <textarea id="textareaFreeRecipient" class="super-compos-default-btn-noshadow form-control"
                  [(ngModel)]="freeRecipient"></textarea>
              </div>
              <div class="col-md-12 d-flex align-items-center justify-content-center">
                <i-button id="buttonValidateAddFreeRecipient" styleClass="blue"
                  [text]="'recipients.validateRecipients' | translate" (click)="addRecipientFree()"></i-button>
              </div>
            </div>
            @if (freeRecipientPool?.length > 0) {
            <app-super-list-simple [items]="freeRecipientPool" [columns]="cols" alignLast="right "
              [boolShowHeader]="false" [boolMultiSelect]="true" (multiSelectValue)="onChangeFreeRecipient($event)"
              [boolImageMode]="true" icon="icon-start-full" [deletable]="true">
            </app-super-list-simple>
            }
          </div>
          }
        </section>
      </div>
    </div>
  </div>
  }
</div>